import * as ApiManager from './_manager';
import store from '../store';

export const user = {
  get: payload => {
    return ApiManager.callApi (`/member/get`, payload);
  },
  update: payload => {
    return ApiManager.callApi (`/member/update`, payload);
  },
  setGapiToken: payload => {
    return ApiManager.callApi (
      `/member/${store.getters['user/getUser'].id}/gapi_token`,
      payload
    );
  },
};
